<script>
  import { Images } from '@client/pages/brandkit/components';

  /** @type {boolean} */
  export let active = false;
  /** @type {string} */
  export let value = '';
  /** @type {(url: string) => void} */
  export let onSelect = () => {};
</script>

<Images {active} selectable bind:value {onSelect} minWidth={800} minHeight={600} />
